import React, { useState, useEffect,useContext } from 'react';
import { useTheme } from '@emotion/react';
import {Box,CircularProgress,Paper,Typography,Button,Table,TableBody,TableCell,TableContainer,TablePagination,TableHead,TableRow,Dialog,
  DialogTitle,DialogContent,DialogActions,TextField,Tabs,Tab,IconButton,Tooltip,Chip,Stack,FormControl,InputLabel,Select,
  MenuItem,Switch,FormControlLabel,FormGroup,Checkbox,RadioGroup,Radio,Card,CardContent,useMediaQuery,ListItemText,
  Divider,Snackbar,Alert} from '@mui/material';
import {Add as AddIcon,Edit as EditIcon,Delete as DeleteIcon,RadioButtonChecked as RadioIcon,ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon} from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import api from '../api';
import Modal from '@mui/material/Modal';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import PillComponent from '../customcomponents/CustomPillComponent';
import EditButton from '../customcomponents/CustomEditButton';
import DeleteButton from '../customcomponents/CustomDeleteButton';
import { SettingsContext } from '../App';

// Tab Panel Component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function RolesAndServicesPage() {
  const {settings,userRole}=useContext(SettingsContext);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [tabValue, setTabValue] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState('');
  const [formData, setFormData] = useState({});
  const [selectedRole, setSelectedRole] = useState('');
  const [roleServices, setRoleServices] = useState([]);
  const [selectedService, setSelectedService] = useState('');
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [openQuestionDialog, setOpenQuestionDialog] = useState(false);
  const [services, setServices] = useState([]);
  const [serviceQuestions, setServiceQuestions] = useState({}); // Store questions by service ID
  const [expandedService, setExpandedService] = useState(null); // Track expanded service accordion
  const [newService, setNewService] = useState({ name: '', description: '' });
  const [editingService, setEditingService] = useState(null);
  const [nameError, setNameError] = useState('');

  // State for service questions modal
  const [serviceQuestionsModalOpen, setServiceQuestionsModalOpen] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const canAccess = (keyName) => {
    const item = settings?.find(s => s.keyName === keyName);
    return item?.roles?.some(r => r.roleName === userRole);
  };
  const canEnableLiveTracking=canAccess("roles_live_tracking");


  // Sample data for roles
  const theme=useTheme();
  const [roles, setRoles] = useState([]);
  const isSmallScreen = useMediaQuery('(max-width:800px)');


    const handleChangePage = (event, newPage) => setPage(newPage);
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

  // Fetch roles from API
  const fetchRoles = async () => {
    try {

    
      const res = await api.get('/roles');

      // Support array, {roles: [...]}, or {data: [...]}  
      let rolesArr = [];
      if (Array.isArray(res.data.data)) {
        rolesArr = res.data.data;
      }
      if(userRole.toLowerCase() ==='admin'){
        rolesArr=rolesArr.filter(role=>role?.TA_Role_Name.toLowerCase()!='superadmin');
      }
      setRoles(rolesArr);
    } catch (err) {
      setRoles([]);
      console.error('Failed to fetch roles:', err);
    }
  };

  // Fetch services from API
  const fetchServices = async () => {
    try {
      const res = await api.get('/services');
      let servicesArr = [];
      if (Array.isArray(res.data.data)) {
        servicesArr = res.data.data.map(s => ({
          _id: s._id,  // Use _id to match MongoDB field name
          name: s.TA_Service_Name,
          description: s.TA_Service_Description,
          status: s.TA_Service_Status === 1 ? 'Active' : 'Inactive',
          price: s.TA_Service_Amount || '',
          // Add other fields as needed
        }));
      }
      setServices(servicesArr);
      return servicesArr; // Return the services for use in other functions
    } catch (err) {
      setServices([]);
      console.error('Failed to fetch services:', err);
      return [];
    }
  };

  // Fetch service questions
  const fetchServiceQuestions = async (serviceId) => {
    if (!serviceId) {
      console.error('No serviceId provided to fetchServiceQuestions');
      return;
    }
    
    try {
      const response = await api.get(`/questionnaire/service/${serviceId}`);
      console.log('Service questions response:', response);
      
      // Handle the API response format: {success: boolean, count: number, data: Array}
      let questions = [];
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        questions = response.data.data;
      } else if (Array.isArray(response.data)) {
        // Fallback: if response.data is directly an array
        questions = response.data;
      } else if (response.data && Array.isArray(response.data.questions)) {
        // Fallback: if questions are in a questions property
        questions = response.data.questions;
      }
      
      // Map the API response to our internal format
      const mappedQuestions = questions.map(q => ({
        _id: q._id || q.id,
        questionText: q.questionText || q.question || '',
        questionType: q.questionType || 'text',
        pattern: q.pattern || 'text',
        required: q.required || q.isRequired || false,
        options: Array.isArray(q.options) ? q.options : [],
        placeholder: q.placeholder || '',
        serviceRef: q.serviceRef
      }));
      
      setServiceQuestions(prev => ({
        ...prev,
        [serviceId]: mappedQuestions
      }));

      // Also update questionnaireQuestions if this is the selected service
      if (selectedService === serviceId) {
        setQuestionnaireQuestions(mappedQuestions);
      }
    } catch (error) {
      console.error('Error fetching service questions:', error);
      // Initialize with empty array if fetch fails
      setServiceQuestions(prev => ({
        ...prev,
        [serviceId]: []
      }));
    }
  };

  // Handle service accordion expand
  const handleServiceExpand = (serviceId) => {
    setExpandedService(expandedService === serviceId ? null : serviceId);
    if (!serviceQuestions[serviceId]) {
      fetchServiceQuestions(serviceId);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchServices();
  }, []);

  // Sample data for role-based permissions
  const rolePermissions = [
    {
      roleId: 1,
      roleName: 'Admin',
      services: [
        { serviceId: 1, serviceName: 'Second Opinion', status: true },
        { serviceId: 2, serviceName: 'Appointment Booking', status: true },
        { serviceId: 3, serviceName: 'Health Checkup', status: true },
        { serviceId: 4, serviceName: 'Consultation', status: true },
      ]
    },
    {
      roleId: 2,
      roleName: 'Staff',
      services: [
        { serviceId: 1, serviceName: 'Second Opinion', status: true },
        { serviceId: 2, serviceName: 'Appointment Booking', status: true },
        { serviceId: 3, serviceName: 'Health Checkup', status: true },
        { serviceId: 4, serviceName: 'Consultation', status: true },
      ]
    },
    {
      roleId: 3,
      roleName: 'PRO',
      services: [
        { serviceId: 1, serviceName: 'Second Opinion', status: true },
        { serviceId: 2, serviceName: 'Appointment Booking', status: true },
        { serviceId: 3, serviceName: 'Health Checkup', status: false },
        { serviceId: 4, serviceName: 'Consultation', status: true },
      ]
    },
    {
      roleId: 4,
      roleName: 'Expert',
      services: [
        { serviceId: 1, serviceName: 'Second Opinion', status: true },
        { serviceId: 2, serviceName: 'Appointment Booking', status: true },
        { serviceId: 3, serviceName: 'Health Checkup', status: true },
        { serviceId: 4, serviceName: 'Consultation', status: false },
      ]
    },
    {
      roleId: 5,
      roleName: 'Public User',
      services: [
        { serviceId: 1, serviceName: 'Second Opinion', status: false },
        { serviceId: 2, serviceName: 'Appointment Booking', status: true },
        { serviceId: 3, serviceName: 'Health Checkup', status: false },
        { serviceId: 4, serviceName: 'Consultation', status: true },
      ]
    }
  ];

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleAdd = (type) => {
    setDialogType(type);
    setFormData({});
    setOpenDialog(true);
  };

  const handleEdit = async (item, type) => {
    setDialogType(type);
    try {
      if (type === 'service') {
        const response = await api.get(`/services/${item._id}`);
        const serviceData = response.data.data;
        setFormData({
          id: serviceData._id,
          name: serviceData.TA_Service_Name,
          description: serviceData.TA_Service_Description,
          price: serviceData.TA_Service_Amount,
          status: serviceData.TA_Service_Status,
          serviceId: serviceData.TA_Service_Service_Ref
        });
      } else {
        // For role editing
        const response = await api.get(`/roles/${item._id}`);
        const roleData = response.data.data;
        setFormData({
          id: roleData._id,
          name: roleData.TA_Role_Name,
          status: roleData.TA_Role_Status || 1,
          serviceId: roleData.TA_Role_Service_Ref,
          isLiveTrackingEnabled:roleData.TA_isLiveTrackingEnabled,
          isAdminRole:roleData.TA_Role_Type,
        });
      }
      setOpenDialog(true);
    } catch (error) {
      console.error(`Error fetching ${type} details:`, error);
      alert(`Failed to load ${type} details: ` + (error.response?.data?.message || error.message));
    }
  };

  const handleDelete = (id, type) => {
  setItemToDelete({ id, type });
  setDeleteDialogOpen(true);
};

  const handleSubmit = async () => {
    if (dialogType === 'role') {
      try {
        const payload = {
          TA_Role_Name: formData.name,
          TA_Role_Type: formData.isAdminRole || 0, 
          TA_Role_Status: formData.status || 1,
          TA_Role_Service_Ref: formData.serviceId || [],
          TA_isLiveTrackingEnabled:formData.isLiveTrackingEnabled || 0
        };
        console.log('payload1',payload);
        if (formData.id) {
          // Update existing role
          await api.put(`/roles/${formData.id}`, payload);
          setSnackbar({ open: true, message: 'Role updated successfully!', severity: 'success' });
          // alert('Role updated successfully!');
        } else {
          // Create new role
          await api.post('/roles', payload);
          // alert('Role added successfully!');
          setSnackbar({ open: true, message: 'Role Added successfully!', severity: 'success' });
        }
        
        await fetchRoles(); // Refresh roles list from API
      } catch (error) {
        console.error('Error saving role:', error);
        // alert('Failed to save role: ' + (error.response?.data?.message || error.message));
        setSnackbar({ open: true, message: 'Failed to save role: ' + (error.response?.data?.message || error.message), severity: 'error' });
      }
    } else {
      try {
        const payload = {
          TA_Service_Name: formData.name,
          TA_Service_Amount: formData.price,
          TA_Service_Description: formData.description,
          TA_Service_Status: formData.status || 1 // Use existing status or default to Active
        };
        
        if (formData.id) {
          // Update existing service
          await api.put(`/services/${formData.id}`, payload);
          // alert('Service updated successfully!');
          setSnackbar({ open: true, message: 'Service updated successfully!', severity: 'success' });
        } else {
          // Create new service
          await api.post('/services', payload);
          // alert('Service added successfully!');
          setSnackbar({ open: true, message: 'Service added successfully!', severity: 'success' });
        }
        
        await fetchServices(); // Refresh services list from API
      } catch (error) {
        console.error('Error saving service:', error);
        // alert('Failed to save service: ' + (error.response?.data?.message || error.message));
        setSnackbar({ open: true, message: 'Failed to save service: ' + (error.response?.data?.message || error.message), severity: 'error' });
      }
    }
    setOpenDialog(false);
  };

  const fetchRoleServices = async (roleId) => {
    try {
      const response = await api.get(`/roles/${roleId}/services`);
      
      if (response.data && response.data.success) {
        const roleServices = response.data.data || [];
        
        // Map the API response to the expected format
        const servicesWithPermissions = roleServices.map(service => ({
          id: service.service_id,
          urs_id: service.urs_id, // Keep the relationship ID for updates
          name: service.service_name,
          hasAccess: service.status === 1 // Assuming status 1 means active
        }));
        
        setRoleServices(servicesWithPermissions);
      } else {
        setRoleServices([]);
      }
    } catch (error) {
      console.error('Error fetching role services:', error);
      // alert('Failed to load role services: ' + (error.response?.data?.message || error.message));
      setSnackbar({ open: true, message: 'Failed to load role services: ' + (error.response?.data?.message || error.message), severity: 'error' });
      setRoleServices([]);
    }
  };

  const handleRoleSelect = async (roleId) => {
    setSelectedRole(roleId);
    if (roleId) {
      await fetchRoleServices(roleId);
    } else {
      setRoleServices([]);
    }
  };

  const updateRoleServices = async (serviceId, newStatus) => {
    try {
      // First, update the local state optimistically
      const updatedServices = roleServices.map(service =>
        service._id === serviceId
          ? { ...service, hasAccess: newStatus }
          : service
      );
      
      setRoleServices(updatedServices);
      
      // Find the service to get the urs_id
      const service = roleServices.find(s => s._id === serviceId);
      
      if (!service?.urs_id) {
        throw new Error('Service relationship ID not found');
      }
      
      // Use the single endpoint with status parameter
      // status: 1 for assign, 0 for unassign
      await api.patch(`/roles/services/${service.urs_id}`, {
        status: newStatus ? 1 : 0
      });
      
      // Refresh the list to ensure consistency
      await fetchRoleServices(selectedRole);
      
    } catch (error) {
      console.error('Error updating role services:', error);
      // alert('Failed to update role services: ' + (error.response?.data?.message || error.message));
      setSnackbar({ open: true, message: 'Failed to update role services: ' + (error.response?.data?.message || error.message), severity: 'error' });
      
      // Revert the local state on error
      fetchRoleServices(selectedRole);
    }
  };

  const handlePermissionToggle = async (serviceId, newStatus) => {
    await updateRoleServices(serviceId, newStatus);
  };

  const handleAnswerChange = (questionId, answer) => {
    setSelectedAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const handleSubmitQuestionnaire = () => {
    console.log('Questionnaire submitted:', selectedAnswers);
    // alert('Thank you for submitting the questionnaire!');
    setSnackbar({ open: true, message: 'Thank you for submitting the questionnaire!', severity: 'success' });
    setSelectedAnswers({});
    setSelectedService('');
  };

  const handleAddQuestion = () => {
    // Since serviceQuestionnaires is now a constant, we'll just open the dialog
    // to add a new question to the questionnaire
    setNewQuestion(createBlankQuestion());
    setOpenQuestionDialog(true);
  };

  const handleSaveQuestion = async () => {
    if (!newQuestion.question.trim()) {
      setSnackbar({ open: true, message: 'Please enter a question', severity: 'error' });
      return;
    }

    try {
      // Map question to the expected backend schema
      const questionData = {
        questionText: newQuestion.question,
        questionType: newQuestion.pattern === 'text' ? 'text' : 'choice',
        serviceRef: selectedService,
        pattern: newQuestion.pattern,
        options: newQuestion.options.map(option => ({
          text: option.text,
          value: option.value || option.text.toLowerCase().replace(/\s+/g, '_')
        })),
        required: newQuestion.required || false,
        isActive: true
      };

      // console.log('Saving question:', { 
      //   isEditing: !!newQuestion.id, 
      //   questionId: newQuestion.id,
      //   questionData 
      // });

      let savedQuestion;
      const isEditing = !!newQuestion.id;
      
      // Make API call to save the question
      if (isEditing) {
        // Update existing question
        const response = await api.put(`/questionnaire/${newQuestion.id}`, questionData);
        savedQuestion = response.data.data;
        // console.log('Updated question response:', response.data);
        setSnackbar({ open: true, message: 'Question updated successfully!', severity: 'success' });
      } else {
        // Create new question
        const response = await api.post('/questionnaire', questionData);
        savedQuestion = response.data.data;
        // console.log('New question response:', response.data);
        setSnackbar({ open: true, message: 'Question added successfully!', severity: 'success' });
      }

      // Update the local state with the new/updated question
      if (selectedService && savedQuestion) {
        // Format the saved question to match our UI structure
        const formattedQuestion = {
          _id: savedQuestion._id || savedQuestion.id || newQuestion.id,
          questionText: savedQuestion.questionText || savedQuestion.question || newQuestion.question,
          questionType: savedQuestion.questionType || 'text',
          pattern: savedQuestion.pattern || newQuestion.pattern || 'text',
          required: savedQuestion.required || savedQuestion.isRequired || newQuestion.required || false,
          options: Array.isArray(savedQuestion.options) ? savedQuestion.options : newQuestion.options,
          placeholder: savedQuestion.placeholder || newQuestion.placeholder || '',
          serviceRef: savedQuestion.serviceRef || selectedService
        };

        // console.log('Formatted question:', formattedQuestion);
        // console.log('Is editing:', isEditing);

        if (isEditing) {
          // Update existing question in serviceQuestions state
          setServiceQuestions(prev => {
            const updatedServices = {
              ...prev,
              [selectedService]: (prev[selectedService] || []).map(q => 
                q._id === newQuestion.id ? formattedQuestion : q
              )
            };
            // console.log('Updated service questions:', updatedServices[selectedService]);
            return updatedServices;
          });

          // Also update the questionnaireQuestions state if we're on the questionnaire tab
          setQuestionnaireQuestions(prev => {
            const updatedQuestions = prev.map(q => 
              q._id === newQuestion.id ? formattedQuestion : q
            );
            // console.log('Updated questionnaire questions:', updatedQuestions);
            return updatedQuestions;
          });
        } else {
          // Add new question to serviceQuestions state
          setServiceQuestions(prev => {
            const updatedServices = {
              ...prev,
              [selectedService]: [...(prev[selectedService] || []), formattedQuestion]
            };
            // console.log('Added to service questions:', updatedServices[selectedService]);
            return updatedServices;
          });

          // Also update the questionnaireQuestions state if we're on the questionnaire tab
          setQuestionnaireQuestions(prev => {
            const updatedQuestions = [...prev, formattedQuestion];
            // console.log('Added to questionnaire questions:', updatedQuestions);
            return updatedQuestions;
          });
        }
      }

      // Reset form and close the dialog
      setNewQuestion(createBlankQuestion());
      setOpenQuestionDialog(false);

    } catch (error) {
      console.error('Error saving question:', error);
      setSnackbar({ 
        open: true, 
        message: 'Failed to save question: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  useEffect(()=>{

  },[handleSaveQuestion]);

  // Helper function to map UI question types to backend types
  const mapQuestionType = (pattern) => {
    switch (pattern) {
      case 'single':
      case 'radio':
        return 'radio';
      case 'multiple':
      case 'checkbox':
        return 'checkbox';
      case 'dropdown':
        return 'dropdown';
      case 'text':
      case 'textarea':
        return 'text';
      default:
        return 'text';
    }
  };

  // Helper: create a blank question object with name, type, pattern, and options
  const createBlankQuestion = () => ({
    name: '',
    type: 'single',
    pattern: 'text',
    question: '',
    options: [
      {
        text: 'Option 1',
        value: 'option1'
      }
    ],
    required: false,
    placeholder: ''
  });

  const [newQuestion, setNewQuestion] = useState(createBlankQuestion());

  // Recursive handler to update a question or its sub-questions
  const updateQuestionAtPath = (question, path, updater) => {
    if (path.length === 0) return updater(question);
    const [head, ...rest] = path;
    if (head === 'children') {
      // Traverse into children array
      const childIdx = rest[0];
      return {
        ...question,
        children: question.children.map((child, idx) =>
          idx === childIdx
            ? updateQuestionAtPath(child, rest.slice(1), updater)
            : child
        )
      };
    } else if (question.pattern === 'single') {
      // Traverse into options array
      return {
        ...question,
        options: question.options.map((opt, idx) =>
          idx === head
            ? {
              ...opt, children: opt.children.map((child, cidx) =>
                rest.length > 0 && rest[0] === cidx
                  ? updateQuestionAtPath(child, rest.slice(1), updater)
                  : child
              )
            }
            : opt
        )
      };
    }
    return question;
  };

  // Add option at path
  const handleAddOption = (path = []) => {
    setNewQuestion(prev => {
      const addOpt = q => ({
        ...q,
        options: [...q.options, { text: '', children: [] }]
      });
      if (path.length === 0) return addOpt(prev);
      return updateQuestionAtPath(prev, path, addOpt);
    });
  };

  // Remove option at path
  const handleRemoveOption = (optionIdx, path = []) => {
    setNewQuestion(prev => {
      const removeOpt = q => ({
        ...q,
        options: q.options.filter((_, i) => i !== optionIdx)
      });
      if (path.length === 0) return removeOpt(prev);
      return updateQuestionAtPath(prev, path, removeOpt);
    });
  };

  // Change option text at path
  const handleOptionChange = (optionIdx, value, path = []) => {
    setNewQuestion(prev => {
      const changeOpt = q => ({
        ...q,
        options: q.options.map((opt, i) => i === optionIdx ? { ...opt, text: value } : opt)
      });
      if (path.length === 0) return changeOpt(prev);
      return updateQuestionAtPath(prev, path, changeOpt);
    });
  };

  // Update sub-question add/remove/change logic to support both types
  // Add sub-question to a question (for text) or to an option (for single)
  const handleAddChildQuestion = (optionIdx, path = [], isText = false) => {
    setNewQuestion(prev => {
      if (isText) {
        // Add to children of the question at path
        const addChild = q => ({
          ...q,
          children: [...(q.children || []), createBlankQuestion()]
        });
        if (path.length === 0) return addChild(prev);
        return updateQuestionAtPath(prev, path, addChild);
      } else {
        // Add to children of the option
        const addChild = q => ({
          ...q,
          options: q.options.map((opt, i) =>
            i === optionIdx
              ? { ...opt, children: [...opt.children, createBlankQuestion()] }
              : opt
          )
        });
        if (path.length === 0) return addChild(prev);
        return updateQuestionAtPath(prev, path, addChild);
      }
    });
  };

  // Remove sub-question from a question (for text) or from an option (for single)
  const handleRemoveChildQuestion = (optionIdx, childIdx, path = [], isText = false) => {
    setNewQuestion(prev => {
      if (isText) {
        // Remove from children of the question at path
        const removeChild = q => ({
          ...q,
          children: q.children.filter((_, ci) => ci !== childIdx)
        });
        if (path.length === 0) return removeChild(prev);
        return updateQuestionAtPath(prev, path, removeChild);
      } else {
        // Remove from children of the option
        const removeChild = q => ({
          ...q,
          options: q.options.map((opt, i) =>
            i === optionIdx
              ? { ...opt, children: opt.children.filter((_, ci) => ci !== childIdx) }
              : opt
          )
        });
        if (path.length === 0) return removeChild(prev);
        return updateQuestionAtPath(prev, path, removeChild);
      }
    });
  };

  // Update sub-question field at path (for both types)
  const handleChildQuestionChange = (optionIdx, childIdx, field, value, path = [], isText = false) => {
    setNewQuestion(prev => {
      if (isText) {
        const updateChild = q => ({
          ...q,
          children: q.children.map((child, ci) =>
            ci === childIdx ? { ...child, [field]: value } : child
          )
        });
        if (path.length === 0) return updateChild(prev);
        return updateQuestionAtPath(prev, path, updateChild);
      } else {
        const updateChild = q => ({
          ...q,
          options: q.options.map((opt, i) =>
            i === optionIdx
              ? {
                ...opt,
                children: opt.children.map((child, ci) =>
                  ci === childIdx ? { ...child, [field]: value } : child
                )
              }
              : opt
          )
        });
        if (path.length === 0) return updateChild(prev);
        return updateQuestionAtPath(prev, path, updateChild);
      }
    });
  };

  // Update sub-question pattern at path (and reset options/placeholder)
  const handleChildPatternChange = (optionIdx, childIdx, value, path = [], isText = false) => {
    setNewQuestion(prev => {
      if (isText) {
        const updateChild = q => ({
          ...q,
          children: q.children.map((child, ci) =>
            ci === childIdx
              ? value === 'text'
                ? { ...child, pattern: value, options: [], placeholder: '' }
                : { ...child, pattern: value, options: [{ text: '', children: [] }], placeholder: '' }
              : child
          )
        });
        if (path.length === 0) return updateChild(prev);
        return updateQuestionAtPath(prev, path, updateChild);
      } else {
        const updateChild = q => ({
          ...q,
          options: q.options.map((opt, i) =>
            i === optionIdx
              ? {
                ...opt,
                children: opt.children.map((child, ci) =>
                  ci === childIdx
                    ? value === 'text'
                      ? { ...child, pattern: value, options: [], placeholder: '' }
                      : { ...child, pattern: value, options: [{ text: '', children: [] }], placeholder: '' }
                    : child
                )
              }
              : opt
          )
        });
        if (path.length === 0) return updateChild(prev);
        return updateQuestionAtPath(prev, path, updateChild);
      }
    });
  };

  // Render question form
  const renderQuestionForm = (q) => {
    const handleOptionChange = (oidx, field, value) => {
      setNewQuestion(prev => ({
        ...prev,
        options: prev.options.map((opt, i) =>
          i === oidx ? { ...opt, [field]: value } : opt
        )
      }));
    };

    const handleAddOption = () => {
      setNewQuestion(prev => ({
        ...prev,
        options: [
          ...prev.options,
          {
            text: `Option ${prev.options.length + 1}`,
            value: `option${prev.options.length + 1}`
          }
        ]
      }));
    };

    const handleRemoveOption = (oidx) => {
      setNewQuestion(prev => ({
        ...prev,
        options: prev.options.filter((_, i) => i !== oidx)
      }));
    };

    return (
      <Box>
        <Box display="flex" gap={2} mb={2}>
          <TextField
            label="Question Name (Internal)"
            fullWidth
            value={q.name}
            onChange={e => {
              setNewQuestion(prev => ({
                ...prev,
                name: e.target.value
              }));
            }}
            placeholder="e.g., customer_name, feedback_rating"
            helperText="Internal identifier for this question"
            InputLabelProps={{
              style: {
                color: theme.palette.background.text,
              },
            }}
            InputProps={{
              style: {
                color: theme.palette.background.text,
              },
            }}
          />
          <FormControl fullWidth>
            <InputLabel sx={{color:'background.text'}}>Question Type</InputLabel>
            <Select
              value={q.type}
              label="Question Type"
              onChange={e => {
                const value = e.target.value;
                setNewQuestion(prev => ({
                  ...prev,
                  type: value,
                  pattern:
                    value === 'single'
                      ? 'radio'
                      : value === 'multiple'
                      ? 'checkbox'
                      : value === 'dropdown'
                      ? 'dropdown'
                      : 'text'
                }));
              }}
              sx={{color:'background.text'}}
            >
              {/* <MenuItem value="single" sx={{color:'background.text'}}>Single Choice</MenuItem> */}
              {/* <MenuItem value="multiple" sx={{color:'background.text'}}>Multiple Choice</MenuItem> */}
              {/* <MenuItem value="" sx={{color:'background.text'}} selected disabled>Select Question Type</MenuItem> */}
              <MenuItem value="text" sx={{color:'background.text'}} selected>Text Input</MenuItem>
              {/* <MenuItem value="dropdown" sx={{color:'background.text'}}>Dropdown</MenuItem> */}
            </Select>
          </FormControl>
        </Box>

        <TextField
          label="Question Text"
          fullWidth
          multiline
          rows={2}
          value={q.question}
          onChange={e => {
            setNewQuestion(prev => ({
              ...prev,
              question: e.target.value
            }));
          }}
          placeholder="Enter the question text that users will see..."
          sx={{ mb: 2 }}
          InputLabelProps={{
              style: {
                color: theme.palette.background.text,
              },
            }}
            InputProps={{
              style: {
                color: theme.palette.background.text,
              },
            }}
        />

        <Box display="flex" gap={2} mb={2}>
          {/* <FormControl fullWidth> */}
            {/* <InputLabel sx={{color:'background.text'}}>Answer Pattern</InputLabel>
            <Select
              value={q.pattern}
              label="Answer Pattern"
              sx={{color:'background.text'}}
              onChange={e => {
                const value = e.target.value;
                setNewQuestion(prev => ({
                  ...prev,
                  pattern: value,
                  options: value === 'text' ? [] : [{ text: 'Option 1', value: 'option1' }]
                }));
              }}
            >
              <MenuItem value="radio" sx={{color:'background.text'}}>Radio Buttons</MenuItem>
              <MenuItem value="checkbox" sx={{color:'background.text'}}>Checkboxes</MenuItem>
              <MenuItem value="dropdown" sx={{color:'background.text'}}>Dropdown</MenuItem>
              <MenuItem value="text" sx={{color:'background.text'}}>Text Input</MenuItem>
              <MenuItem value="textarea" sx={{color:'background.text'}}>Long Text</MenuItem>
            </Select> */}
          {/* </FormControl> */}

          <FormControlLabel
            control={
              <Switch
                checked={q.required || false}
                onChange={e => {
                  setNewQuestion(prev => ({
                    ...prev,
                    required: e.target.checked
                  }));
                }}
              />
            }
            label="Required"
            sx={{ minWidth: 120 }}
          />
        </Box>
        {q.pattern === 'text' ? (
          <Box>
            {/* <TextField
              label="Placeholder Text"
              fullWidth
              value={q.placeholder}
              onChange={e => {
                setNewQuestion(prev => ({
                  ...prev,
                  placeholder: e.target.value
                }));
              }}
              placeholder="Enter placeholder text for the text area..."
              sx={{ mb: 2 }}
              InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
            /> */}
          </Box>
        ) : (
          <Box>
            {/* <Typography variant="subtitle1" fontWeight={600} mb={2}>
              Options:
            </Typography>
            {q.options.map((option, oidx) => (
              <Box key={oidx} display="flex" alignItems="center" mb={1} gap={1}>
                <TextField
                  label="Display Text"
                  value={option.text}
                  onChange={e => {
                    handleOptionChange(oidx, 'text', e.target.value);
                  }}
                  placeholder={`Option ${oidx + 1}`}
                  size="small"
                  sx={{ flex: 1 }}
                  helperText="Option display value"
                  InputLabelProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  FormHelperTextProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                />
                <TextField
                  label="Value"
                  value={option.value}
                  onChange={e => {
                    handleOptionChange(oidx, 'value', e.target.value);
                  }}
                  placeholder={option.text || `value${oidx + 1}`}
                  size="small"
                  sx={{ flex: 0.8 }}
                  helperText="Internal value"
                  InputLabelProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  FormHelperTextProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                />
                <IconButton
                  color="error"
                  onClick={() => handleRemoveOption(oidx)}
                  disabled={q.options.length <= 1}
                  sx={{ ml: 1 }}
                  title="Remove option"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))}
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddIcon />}
              onClick={handleAddOption}
              sx={{ mt: 1, textTransform: 'none' }}
            >
              Add Option
            </Button> */}
          </Box>
        )}
      </Box>
    );
  };

  // Sample data for service questionnaires
  const serviceQuestionnaires = {
    1: { // Second Opinion
      serviceName: 'Second Opinion',
      questions: [
        {
          id: 1,
          question: 'What type of medical condition are you seeking a second opinion for?',
          options: ['Cardiology', 'Oncology', 'Neurology', 'Orthopedics', 'Other'],
          pattern: 'single'
        },
        {
          id: 2,
          question: 'Please describe your symptoms in detail:',
          pattern: 'text',
          placeholder: 'Describe your symptoms, duration, and any previous treatments...'
        },
        {
          id: 3,
          question: 'How urgent is your condition?',
          options: ['Very Urgent (within 1 week)', 'Urgent (within 2 weeks)', 'Moderate (within 1 month)', 'Not Urgent'],
          pattern: 'single'
        },
        {
          id: 4,
          question: 'Do you have any existing medical reports?',
          options: ['Yes, I have complete reports', 'Yes, but incomplete', 'No, I need to get reports', 'Not sure'],
          pattern: 'single'
        },
        {
          id: 5,
          question: 'What is your preferred consultation method?',
          options: ['Video Call', 'Audio Call', 'Text Chat', 'In-person (if available)'],
          pattern: 'single'
        },
        {
          id: 6,
          question: 'Any additional information or specific concerns?',
          pattern: 'text',
          placeholder: 'Please share any additional details that might help the doctor...'
        }
      ]
    },
    2: { // Appointment Booking
      serviceName: 'Appointment Booking',
      questions: [
        {
          id: 1,
          question: 'What type of appointment do you need?',
          options: ['General Consultation', 'Specialist Consultation', 'Follow-up', 'Emergency', 'Routine Checkup'],
          pattern: 'single'
        },
        {
          id: 2,
          question: 'Please describe the reason for your appointment:',
          pattern: 'text',
          placeholder: 'Briefly describe your symptoms or reason for the appointment...'
        },
        {
          id: 3,
          question: 'What is your preferred time slot?',
          options: ['Morning (9 AM - 12 PM)', 'Afternoon (12 PM - 3 PM)', 'Evening (3 PM - 6 PM)', 'Night (6 PM - 9 PM)'],
          pattern: 'single'
        },
        {
          id: 4,
          question: 'How soon do you need the appointment?',
          options: ['Today', 'Tomorrow', 'This week', 'Next week', 'Flexible'],
          pattern: 'single'
        },
        {
          id: 5,
          question: 'Do you have any specific doctor preference?',
          options: ['Yes, I have a preferred doctor', 'No, any available doctor', 'I need a specialist', 'Not sure'],
          pattern: 'single'
        },
        {
          id: 6,
          question: 'Any special requirements or notes for the appointment?',
          pattern: 'text',
          placeholder: 'Mobility issues, language preferences, or other special requirements...'
        }
      ]
    },
    3: { // Health Checkup
      serviceName: 'Health Checkup',
      questions: [
        {
          id: 1,
          question: 'What type of health checkup do you need?',
          options: ['Basic Health Screening', 'Comprehensive Health Checkup', 'Specialized Screening', 'Annual Physical', 'Pre-employment'],
          pattern: 'single'
        },
        {
          id: 2,
          question: 'Please list any existing health conditions or medications:',
          pattern: 'text',
          placeholder: 'Diabetes, hypertension, heart conditions, current medications, etc...'
        },
        {
          id: 3,
          question: 'What is your age group?',
          options: ['18-30 years', '31-45 years', '46-60 years', '60+ years'],
          pattern: 'single'
        },
        {
          id: 4,
          question: 'Do you have any existing health conditions?',
          options: ['Yes, multiple conditions', 'Yes, one condition', 'No, I am healthy', 'Not sure'],
          pattern: 'single'
        },
        {
          id: 5,
          question: 'What is your preferred checkup package?',
          options: ['Basic Package', 'Standard Package', 'Premium Package', 'Custom Package'],
          pattern: 'single'
        },
        {
          id: 6,
          question: 'Any specific health concerns you want to address?',
          pattern: 'text',
          placeholder: 'Family history, specific symptoms, or health goals...'
        }
      ]
    },
    4: { // Consultation
      serviceName: 'Consultation',
      questions: [
        {
          id: 1,
          question: 'What type of consultation do you need?',
          options: ['General Health', 'Mental Health', 'Nutrition', 'Fitness', 'Chronic Disease Management'],
          pattern: 'single'
        },
        {
          id: 2,
          question: 'Please describe your symptoms or concerns in detail:',
          pattern: 'text',
          placeholder: 'Describe your symptoms, their duration, severity, and any triggers...'
        },
        {
          id: 3,
          question: 'What is the duration of your symptoms?',
          options: ['Less than 1 week', '1-4 weeks', '1-6 months', 'More than 6 months', 'Chronic condition'],
          pattern: 'single'
        },
        {
          id: 4,
          question: 'What is your consultation preference?',
          options: ['First-time consultation', 'Follow-up consultation', 'Emergency consultation', 'Routine consultation'],
          pattern: 'single'
        },
        {
          id: 5,
          question: 'Do you have any specific concerns?',
          options: ['Pain management', 'Medication review', 'Lifestyle advice', 'Diagnostic tests', 'Treatment plan'],
          pattern: 'single'
        },
        {
          id: 6,
          question: 'Any additional information for the doctor?',
          pattern: 'text',
          placeholder: 'Previous treatments, medications, lifestyle factors, or other relevant information...'
        }
      ]
    }
  };

  const renderRolesTable = () => (
      
    <Box sx={{background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',boxShadow: '0 2px 12px rgba(0,0,0,0.06)',borderRadius:'0 0 12px 12px',p:2,m:-3,maxHeight:isSmallScreen?'auto':650 }}>
      <Box sx={{display:'flex',alignItems:'center',background:'background.paper' }} >
        <Typography variant='h6'  fontWeight={600} flex={1} sx={{ color: 'background.text', fontSize:{xs:'14px',sm:'18px'} }}>User Roles</Typography>
        {isSmallScreen ? (
                <Tooltip title="Add Role" arrow>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handleAdd('role')}
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      borderRadius: 3,
                      boxShadow: 2,
                      height: 30,
                      minWidth: 30,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: theme.palette.primary.dark,
                        boxShadow: 4,
                      },
                      flexShrink: 0,
                    }}
                  >
                    Add Role
                  </Button>
                </Tooltip>
            ) : (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => handleAdd('role')}
                sx={{ borderRadius: 3, fontWeight: 700, textTransform: 'none', ml: 'auto',height:50 }}
              >
              Add Role
              </Button>
            )
        }     
      </Box>
      <Divider sx={{margin:'5px'}} />
      <Box>
        <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'auto',mt:3}}>
          <TableContainer sx={{maxHeight:450}}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{  background: '#0088cc',color:'white', fontWeight: 700 , fontSize:{xs:'10px',sm:'14px'}, }}>Sl no</TableCell>
                  <TableCell sx={{  background: '#0088cc',color:'white', fontWeight: 700 , fontSize:{xs:'10px',sm:'14px'}, }}>Role Name</TableCell>
                  <TableCell sx={{  background: '#0088cc',color:'white', fontWeight: 700 , fontSize:{xs:'10px',sm:'14px'},textAlign:'center' }}>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {roles.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        No roles found.
                      </TableCell>
                    </TableRow>
                  ) : (
                    roles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((role, idx) => (
                      <TableRow key={role._id} hover>
                        <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}} >{page * rowsPerPage + idx + 1}</TableCell>
                        <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}} >
                          <Typography variant="subtitle2" sx={{ color:'background.text', fontWeight: 600 , fontSize:{xs:'10px',sm:'14px'},padding:{xs:'10px',sm:'auto'} }}>{role.TA_Role_Name}</Typography>
                        </TableCell>
                        <TableCell>
                          <Stack direction="row" justifyContent={'space-evenly'}>
                            {/* <IconButton size="small" color="primary" onClick={() => handleEdit(role, 'role')}>
                              <EditIcon fontSize="small" />
                            </IconButton> */}
                            <EditButton onClick={() => handleEdit(role, 'role')} />
                            <DeleteButton onClick={() => handleDelete(role._id, 'role')} />
                            {/* <IconButton size="small" color="error" onClick={() => handleDelete(role._id, 'role')}>
                              <DeleteIcon fontSize="small" />
                            </IconButton> */}
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* {isSmallScreen ? null : ( */}
              <Box sx={{ px: 2, py: 1,background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',}}>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={roles.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      sx={{
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {

                        },
                        background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',
                        color: 'background.text',
                        '& .MuiTablePagination-selectLabel, & css-pdct74-MuiTablePagination-selectLabel':{
                          display:{xs:'none',sm:'inherit'}
                        },
                        '& .MuiTablePagination-displayedRows, & .css-levciy-MuiTablePagination-displayedRows':{
                          display:{xs:'none',sm:'inherit'}
                        },
                        '& .MuiSelect-select, & .MuiTablePagination-select, & .MuiSelect-standard, & .MuiInputBase-input, & .css-194a1fa-MuiSelect-select-MuiInputBase-input':{
                          marginLeft:{xs:'-60px',sm:'auto'}
                        },
                        '& .MuiSvgIcon-root, & .MuiSvgIcon-fontSizeMedium, & .MuiSelect-icon, & .MuiTablePagination-selectIcon, & .MuiSelect-iconStandard, & .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon':{
                          marginLeft:{xs:'-80px',sm:'auto'}
                        }
                      }}
                    />
              </Box>
          {/* )} */}
                
        </Paper>
      </Box>
    </Box>
  );

  // Render service questions accordion
  const renderServiceQuestions = (serviceId) => {
    // Ensure we have a valid array
    const questions = Array.isArray(serviceQuestions[serviceId])
      ? serviceQuestions[serviceId]
      : [];

    if (!questions || questions.length === 0) {
      return (
        <Box p={2} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            No questions added yet.
          </Typography>
        </Box>
      );
    }

    return (
      <Box p={2}>
        {questions.map((question, index) => {
          // Ensure we have consistent required flag
          const isRequired = question.required || question.isRequired || false;

          return (
            <Accordion key={question._id || `question-${index}`} defaultExpanded={index === 0}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" fontWeight={500} sx={{color:'background.text'}}>
                  {question.questionText || 'Untitled Question'}
                </Typography>
                <Chip
                  label={isRequired ? 'Required' : 'Optional'}
                  size="small"
                  style={{ marginLeft: 12 }}
                  color={isRequired ? 'primary' : 'success'}
                  variant="outlined"
                />
              </AccordionSummary>
              <AccordionDetails>
                <Box width="100%">
                  <Box mb={2}>
                    <Typography variant="subtitle2" color="background.text" gutterBottom>
                      <strong>Type:</strong> {question.questionType || 'text'}
                    </Typography>
                    {question.pattern && question.pattern !== 'text' && (
                      <Typography variant="caption" color="background.text" display="block">
                        <strong>Pattern:</strong> {question.pattern}
                      </Typography>
                    )}
                    {/* {question.serviceRef && (
                      <Typography variant="caption" color="background.text" display="block">
                        <strong>Service ID:</strong> {question.serviceRef}
                      </Typography>
                    )} */}
                  </Box>

                  {question.options?.length > 0 && (
                    <Box mt={2} mb={2}>
                      <Typography variant="subtitle2" gutterBottom sx={{color:'background.text'}}>
                        <strong>Options:</strong>
                      </Typography>
                      <Box component="ul" sx={{ pl: 2, m: 0, listStyleType: 'none' }}>
                        {question.options.map((option, optIndex) => (
                          <Box component="li" key={optIndex} sx={{ mb: 0.5 }}>
                            <Typography variant="body2" sx={{color:'background.text'}}>
                              • {option.text || 'Untitled option'}
                              {option.value && option.value !== option.text && (
                                <Typography component="span" variant="caption" color="background.text" sx={{ ml: 1 }}>
                                  (Value: {option.value})
                                </Typography>
                              )}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  )}

                  {question.placeholder && (
                    <Box mt={2}>
                      <Typography variant="subtitle2" gutterBottom>
                        <strong>Placeholder:</strong>
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {question.placeholder}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </Box>
    );
  };

  const renderServicesTable = () => (
    <Box sx={{background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',boxShadow: '0 2px 12px rgba(0,0,0,0.06)',borderRadius:'0 0 12px 12px',p:2,m:-3,maxHeight:isSmallScreen?'auto':650}}>
      <Box sx={{display:'flex',alignItems:'center' }} >
        <Typography variant='h6'  fontWeight={600} flex={1} sx={{ color: 'background.text', fontSize:{xs:'14px',sm:'18px'} }}>Services</Typography>
        {isSmallScreen ? (
                <Tooltip title="Add Service" arrow>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => handleAdd('service')}
                    sx={{
                      bgcolor: theme.palette.primary.main,
                      color: theme.palette.primary.contrastText,
                      borderRadius: 3,
                      boxShadow: 2,
                      width: 30,   
                      height: 30,
                      minWidth: 'fit-content',
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: theme.palette.primary.dark,
                        boxShadow: 4,
                      },
                      flexShrink: 0,
                    }}
                  >
                    Add Service
                  </Button>
                </Tooltip>
            ) : (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => handleAdd('service')}
                sx={{ borderRadius: 3, fontWeight: 700, textTransform: 'none', ml: 'auto',height:50 }}
              >
              Add Service
              </Button>
            )
        }     
      </Box>
      <Divider sx={{margin:'5px'}} />
      <Box>
        <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'auto',mt:3}}>
          {
            (()=>{
              if(isSmallScreen){
                return(
                  <>
                    <Box>
                    {services.map((service) => (
                      <Paper
                        key={service._id}
                        elevation={2}
                        sx={{
                          borderRadius: 3,
                          mb: 2,
                          p: 2,
                          display: 'flex',
                          flexDirection: 'column',
                          backgroundColor: 'background.paper',
                        }}
                      >
                        <Box display="flex" flexDirection='column' alignItems="center" justifyContent="center">
                          <Box sx={{display:'flex',gap:2}} >
                            <Box>
                              <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize:{xs:'10px',sm:'16px'}, color:theme.palette.mode === 'dark' ? 'white' : 'black', }}>
                                Service Name :
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="body2" sx={{ fontSize:{xs:'10px',sm:'16px'}, color:theme.palette.mode === 'dark' ? 'white' : 'black', mt: 0.5 }}>
                                {service.name}
                              </Typography>
                            </Box>
                          </Box>
                          <Box sx={{display:'flex',gap:2}} >
                            <Box>
                              <Typography variant="subtitle1" fontWeight={600} sx={{ fontSize:{xs:'10px',sm:'16px'}, color: 'background.text' }}>
                                Description : 
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant="body2" sx={{ fontSize:{xs:'10px',sm:'16px'}, color: 'background.text', mt: 0.5 }}>
                                {service.description || 'No description'}
                              </Typography>
                            </Box>
                          </Box>
                          <Box display="flex" alignItems="center" gap={{xs:0.5,sm:3}} mt={1}>
                            <Chip
                              label={service.isActive ? 'Inactive' : 'Active'}
                              color={service.isActive ? 'default' : 'success'}
                              size="small"
                              sx={{ color: 'white' }}
                            />

                            <Tooltip title="View Service Questions">
                                  <IconButton
                                    size="small"
                                    sx={{color:'primary.main'}}
                                    onClick={() => {
                                      setSelectedService(service._id);
                                      fetchServiceQuestions(service._id);
                                      setServiceQuestionsModalOpen(true);
                                    }}
                                  >
                                  <VisibilityIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Edit">
                              <EditButton onClick={() => handleEdit(service, 'service')} />
                            </Tooltip>

                            <Tooltip title="Delete">
                              <DeleteButton onClick={() => handleDelete(service._id, 'service')} />
                            </Tooltip>
                          </Box>
                        </Box>
                      </Paper>
                    ))}

                    {/* Modal for Service Questions */}
                    <Modal
                      open={!!selectedService && !!serviceQuestionsModalOpen}
                      onClose={() => {
                        setSelectedService(null);
                        setServiceQuestionsModalOpen(false);
                      }}
                      aria-labelledby="service-questions-modal-title"
                      aria-describedby="service-questions-modal-description"
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          width: '90%',
                          maxWidth: 400,
                          bgcolor: 'background.paper',
                          borderRadius: 2,
                          boxShadow: 24,
                          p: 3,
                          outline: 'none',
                        }}
                      >
                        <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                          <Typography id="service-questions-modal-title" variant="h6" fontWeight={600}>
                            Service Questions
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSelectedService(null);
                              setServiceQuestionsModalOpen(false);
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Box>
                        {serviceQuestions[selectedService]?.length > 0 ? (
                          <Box>
                            {serviceQuestions[selectedService].map((q, idx) => (
                              <Box key={q._id || idx} mb={1.5}>
                                <Typography variant="body2" sx={{ color: 'background.text' }}>
                                  {idx + 1}. {q.questionText || q.question || 'Untitled question'}
                                </Typography>
                                </Box>
                            ))}
                          </Box>
                            ) : (
                          <Typography variant="body2" color="background.text">
                            No questions added yet.
                          </Typography>
                        )}  
                      </Box>
                    </Modal>
                    </Box>
                  </>
                )
              }else{
                return(<>
                  <TableContainer sx={{maxHeight:450}}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{  background: '#0088cc',color: 'white', fontWeight: 700 }}>Sl no</TableCell>
                          <TableCell sx={{  background: '#0088cc',color: 'white', fontWeight: 700 }}>Service Name</TableCell>
                          <TableCell sx={{  background: '#0088cc',color: 'white', fontWeight: 700 }}>Description</TableCell>
                          <TableCell sx={{  background: '#0088cc',color: 'white', fontWeight: 700 }}>Status</TableCell>
                          <TableCell sx={{  background: '#0088cc',color: 'white', fontWeight: 700 }}>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      {services.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((service, idx) => (
                        <React.Fragment key={service._id}>
                          <TableRow hover onClick={() => handleServiceExpand(service._id)}>
                            <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}} >{page * rowsPerPage + idx + 1}</TableCell>
                            <TableCell>
                              <Box display="flex" alignItems="center">
                                <IconButton
                                  size="small"
                                  onClick={() => handleServiceExpand(service._id)}
                                >
                                  {expandedService === service._id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                                <Typography variant="subtitle2" fontWeight={600} sx={{ color: 'background.text' }}>
                                  {service.name}
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ color: 'background.text' }}>{service.description || 'No description'}</Typography>
                            </TableCell>
                            <TableCell sx={{ color: 'white' }}>
                              {/* <Chip
                                label={service.isActive ? 'Inactive' : 'Active'}
                                color={service.isActive ? 'default' : 'success'}
                                size="small"
                                sx={{ color: 'white' }}
                              /> */}
                              <PillComponent />
                            </TableCell>
                            <TableCell sx={{ color: 'background.text' }}>
                              <Box display="flex" gap={1}>
                                <Tooltip title="Edit">
                                  <EditButton onClick={() => handleEdit(service, 'service')} />
                                </Tooltip>
                                {/* <Tooltip title="Add Question">
                                  <IconButton
                                    size="small"
                                    color="secondary"
                                    onClick={() => {
                                      setSelectedService(service._id);
                                      handleAddQuestion();
                                    }}
                                  >
                                    <AddIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip> */}
                                <Tooltip title="Delete">
                                  <DeleteButton onClick={() => handleDelete(service._id, 'service')} />
                                </Tooltip>
                              </Box>
                            </TableCell>
                          </TableRow>
                          {expandedService === service._id && (
                            <TableRow>
                              <TableCell colSpan={5} sx={{ p: 0 }}>
                                <Box p={2} bgcolor="background.paper">
                                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} >
                                    <Typography variant="subtitle1" fontWeight={600} sx={{color:'background.text'}}>
                                      Service Questions
                                    </Typography>
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      startIcon={<AddIcon />}
                                      onClick={() => {
                                        setSelectedService(service._id);
                                        handleAddQuestion();
                                      }}
                                    >
                                      Add Question
                                    </Button>
                                  </Box>
                                  {serviceQuestions[service._id]?.length > 0 ? (
                                    renderServiceQuestions(service._id)
                                  ) : (
                                    <Box textAlign="center" py={4}>
                                      <Typography variant="body2" color="background.text">
                                        No questions added yet. Click the button above to add one.
                                      </Typography>
                                    </Box>
                                  )}
                                </Box>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* {isSmallScreen ? null : ( */}
                      <Box sx={{ px: 2, py: 1, background:theme.palette.mode === 'dark' ? 'transparent' : '#fff', }}>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25]}
                              component="div"
                              count={services.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              sx={{
                                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        
                                },
                                background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',
                                color: 'background.text',
                                '& .MuiTablePagination-selectLabel, & css-pdct74-MuiTablePagination-selectLabel':{
                                  display:{xs:'none',sm:'inherit'}
                                },
                                '& .MuiTablePagination-displayedRows, & .css-levciy-MuiTablePagination-displayedRows':{
                                  display:{xs:'none',sm:'inherit'}
                                },
                                '& .MuiSelect-select, & .MuiTablePagination-select, & .MuiSelect-standard, & .MuiInputBase-input, & .css-194a1fa-MuiSelect-select-MuiInputBase-input':{
                                  marginLeft:{xs:'-60px',sm:'auto'}
                                },
                                '& .MuiSvgIcon-root, & .MuiSvgIcon-fontSizeMedium, & .MuiSelect-icon, & .MuiTablePagination-selectIcon, & .MuiSelect-iconStandard, & .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon':{
                                  marginLeft:{xs:'-80px',sm:'auto'}
                                }
                              }}
                            />
                      </Box>
                  {/* )} */}
                </>)
              }
            })()
          }
                
        </Paper>
      </Box>
    </Box>
  );

  // const renderRolePermissionsTable = () => {
  //   return (
  //     <Box>

  //       <Paper elevation={1} sx={{borderBottomLeftRadius:15,borderBottomRightRadius: 15,  borderColor: 'divider',p:2,m:-3,maxHeight:isSmallScreen?'auto':650}}>      
  //         {isSmallScreen ? (
  //           <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap={{ xs: 'wrap', sm: 'nowrap' }} padding={1}>
  //             <Typography variant='h6'  fontWeight={600} flex={1} sx={{ color: 'background.text', fontSize:{xs:'14px',sm:'18px'} }}>
  //               Role-Based
  //             </Typography>
  //             <FormControl size="small" sx={{   minWidth: { xs: 100, sm: 150},   flexShrink: 0 }}>
  //               <InputLabel sx={{ color: 'background.text' , fontSize: 13}}>Select</InputLabel>
  //               <Select value={selectedRole} label="Select Role" onChange={(e) => handleRoleSelect(e.target.value)}
  //                 sx={{  borderRadius: 2,  color: 'background.text',  width: { xs: 100, sm: 140 },fontSize: 13,height: 32,'& .MuiSelect-select': {py: 0.5},}}>
  //                 {roles.map((role) => (
  //                   <MenuItem key={role._id} value={role._id} sx={{ color: 'background.text',fontSize: 13 }}>
  //                     {role.TA_Role_Name}
  //                   </MenuItem>
  //                 ))}
  //               </Select>
  //             </FormControl>
  //           </Box>
  //         ) : (
  //           <Box display="flex" justifyContent="space-between" alignItems="center" gap={2} flexWrap={{ xs: 'wrap', sm: 'nowrap' }}>
  //             <Typography variant='h6'  fontWeight={600} flex={1} sx={{ color: 'background.text', fontSize:{xs:'14px',sm:'18px'} }}>
  //               Role-Based Permissions
  //             </Typography>
  //             <FormControl sx={{   minWidth: { xs: 150, sm: 200},   flexShrink: 0 }}>
  //               <InputLabel sx={{ color: 'background.text' }}>Select Role</InputLabel>
  //               <Select value={selectedRole} label="Select Role" onChange={(e) => handleRoleSelect(e.target.value)}
  //                 sx={{  borderRadius: 2,  color: 'background.text',  width: { xs: '150px', sm: 'auto' }}}>
  //                 {roles.map((role) => (
  //                   <MenuItem key={role._id} value={role._id} sx={{ color: 'background.text' }}>
  //                     {role.TA_Role_Name}
  //                   </MenuItem>
  //                 ))}
  //               </Select>
  //             </FormControl>
  //           </Box>
  //         )}

  //         <Divider sx={{margin:'5px'}} />

  //         <Box sx={{backgroundColor:'',padding:3,mt:3}} >
  //             {selectedRole ? (
  //               <>
  //               <Paper elevation={1} sx={{ borderRadius: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'auto',mt:3}}>
  //                   <TableContainer>
  //                     <Table>
  //                       <TableHead>
  //                         <TableRow sx={{ bgcolor: 'primary.main' }}>
  //                           <TableCell sx={{ color: 'white', fontWeight: 700 }}>
  //                             <Typography variant="subtitle2" sx={{  fontWeight: 600 , fontSize:{xs:'10px',sm:'14px'} }}>Sl no</Typography>
  //                           </TableCell>
  //                           <TableCell sx={{ color: 'white', fontWeight: 700 }}>
  //                             <Typography variant="subtitle2" sx={{  fontWeight: 600 , fontSize:{xs:'10px',sm:'14px'} }}>Service Name </Typography>
  //                           </TableCell>
  //                           <TableCell sx={{ color: 'white', fontWeight: 700 }}>
  //                             <Typography variant="subtitle2" sx={{  fontWeight: 600 , fontSize:{xs:'10px',sm:'14px'},textAlign:'center' }}>Access </Typography>
  //                           </TableCell>
  //                         </TableRow>
  //                       </TableHead>
  //                         <TableBody>
  //                         {roleServices.length === 0 ? (
  //                             <TableRow>
  //                               <TableCell colSpan={2} align="center">
  //                                 No services found or failed to load services.
  //                               </TableCell>
  //                             </TableRow>
  //                           ) : (
  //                             roleServices.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((service, idx) => (
  //                               <TableRow key={service._id} hover>
  //                                 <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}} >{page * rowsPerPage + idx + 1}</TableCell>
  //                                 <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}} >
  //                                   <Typography variant="subtitle2" sx={{ color:'background.text', fontWeight: 600 , fontSize:{xs:'10px',sm:'14px'},padding:{xs:'10px',sm:'auto'} }}>{service.name}</Typography>
  //                                 </TableCell>
  //                                 <TableCell sx={{padding:{xs:'2px 13px',sm:'auto'}}}  align="center">
  //                                   <Switch
  //                                     checked={!!service.hasAccess}
  //                                     onChange={(e) => handlePermissionToggle(service._id, e.target.checked)}
  //                                     color="primary"
  //                                     inputProps={{ 'aria-label': `${service.name} access control` }}
  //                                   />
  //                                 </TableCell>
  //                               </TableRow>
  //                             ))
  //                           )}
  //                       </TableBody>
  //                     </Table>
  //                   </TableContainer>
  //                   {/* {isSmallScreen ? null : ( */}
  //                       <Box sx={{ px: 2, py: 1, background:theme.palette.mode === 'dark' ? 'transparent' : '#fff', }}>
  //                         <TablePagination
  //                             rowsPerPageOptions={[5, 10, 25]}
  //                             component="div"
  //                             count={roleServices.length}
  //                             rowsPerPage={rowsPerPage}
  //                             page={page}
  //                             onPageChange={handleChangePage}
  //                             onRowsPerPageChange={handleChangeRowsPerPage}
  //                             sx={{
  //                               '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        
  //                               },
  //                               background:theme.palette.mode === 'dark' ? 'transparent' : '#fff',
  //                               color: 'background.text',
  //                               '& .MuiTablePagination-selectLabel, & css-pdct74-MuiTablePagination-selectLabel':{
  //                                 display:{xs:'none',sm:'inherit'}
  //                               },
  //                               '& .MuiTablePagination-displayedRows, & .css-levciy-MuiTablePagination-displayedRows':{
  //                                 display:{xs:'none',sm:'inherit'}
  //                               },
  //                               '& .MuiSelect-select, & .MuiTablePagination-select, & .MuiSelect-standard, & .MuiInputBase-input, & .css-194a1fa-MuiSelect-select-MuiInputBase-input':{
  //                                 marginLeft:{xs:'-60px',sm:'auto'}
  //                               },
  //                               '& .MuiSvgIcon-root, & .MuiSvgIcon-fontSizeMedium, & .MuiSelect-icon, & .MuiTablePagination-selectIcon, & .MuiSelect-iconStandard, & .css-pqjvzy-MuiSvgIcon-root-MuiSelect-icon':{
  //                                 marginLeft:{xs:'-80px',sm:'auto'}
  //                               }
  //                             }}
  //                           />
  //                       </Box>
  //                   {/* )} */}
  //               </Paper>
  //               </>
  //             ) : (
  //               <Paper elevation={2} sx={{ p: 4, textAlign: 'center', borderRadius: 3 , m:-3 }}>
  //                 <Typography variant="h6" color="background.text">
  //                   Please select a role to view its service permissions
  //                 </Typography>
  //               </Paper>
  //             )}
  //         </Box>
  //       </Paper>

  //     </Box>
  //   );
  // };


// Handle edit question
const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
const [questionToDelete, setQuestionToDelete] = useState(null);
const [itemToDelete, setItemToDelete] = useState({ id: null, type: null });


  const handleEditQuestion = (question) => {
    console.log('Editing question:', question);
    
    // Set the question data to edit
    setNewQuestion({
      id: question._id || question.id, // Use both possible ID fields
      name: question.name || '',
      type: question.questionType || 'text',
      pattern: question.pattern || 'text',
      question: question.questionText || question.question || '',
      options: question.options ? question.options.map(opt => ({
        text: typeof opt === 'string' ? opt : (opt.text || ''),
        value: typeof opt === 'string' ? opt.toLowerCase().replace(/\s+/g, '_') : (opt.value || (opt.text && opt.text.toLowerCase().replace(/\s+/g, '_')) || '')
      })) : [],
      required: question.required || false,
      placeholder: question.placeholder || ''
    });
    
    setOpenQuestionDialog(true);
  };

  // Handle delete question
 const handleDeleteQuestionClick = (questionId) => {
  setQuestionToDelete(questionId);
  setDeleteDialogOpen(true);
};

const handleDeleteCancel = () => {
  setDeleteDialogOpen(false);
  setQuestionToDelete(null);
  setItemToDelete({ id: null, type: null });
};

const handleDeleteConfirm = async () => {
  const { id, type } = itemToDelete;

  try {
    if (type === 'service') {
      await api.delete(`/services/${id}`);
      // alert('Service deleted successfully!');
      setSnackbar({ open: true, message: 'Service deleted successfully!', severity: 'success' });
      await fetchServices(); // Refresh services list
    } else {
      await api.delete(`/roles/${id}`);
      // alert('Role deleted successfully!');
      setSnackbar({ open: true, message: 'Role deleted successfully!', severity: 'success' });
      await fetchRoles(); // Refresh roles list
    }
  } catch (error) {
    console.error(`Error deleting ${type}:`, error);
    // alert(`Failed to delete ${type}: ` + (error.response?.data?.message || error.message));
    setSnackbar({ open: true, message: `Failed to delete ${type}`+(error.response?.data?.message || error.message), severity: 'error' });
  } finally {
    handleDeleteCancel(); // Close dialog and clear state
  }
  if (!questionToDelete) return;

  try {
    await api.delete(`/questionnaire/${questionToDelete}`);

    if (selectedService) {
      setServiceQuestions(prev => ({
        ...prev,
        [selectedService]: (prev[selectedService] || []).filter(q => q._id !== questionToDelete)
      }));
    }

    setQuestionnaireQuestions(prev =>
      prev.filter(q => q._id !== questionToDelete)
    );

    setSnackbar({ open: true, message: 'Question deleted successfully', severity: 'success' });
  } catch (error) {
    console.error('Error deleting question:', error);
    setSnackbar({
      open: true,
      message: 'Failed to delete question: ' + (error.response?.data?.message || error.message),
      severity: 'error'
    });
  } finally {
    setDeleteDialogOpen(false);
    setQuestionToDelete(null);
  }
};



  // Render question accordion item
  const renderQuestionAccordion = (question, index, level = 0) => {
    const hasChildren = question.children && question.children.length > 0;

    return (
      <Accordion
        key={question.id}
        defaultExpanded={index === 0 && level === 0}
        disableGutters
        elevation={0}
        sx={{
          '&:before': {
            display: 'none',
          },
          mb: 1,
          ml: level * 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <AccordionSummary
          expandIcon={hasChildren ? <ExpandMoreIcon /> : null}
          sx={{
            backgroundColor: 'background.paper',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
            '&.Mui-expanded': {
              minHeight: 48,
              '& .MuiAccordionSummary-content': {
                margin: '12px 0',
              },
            },
          }}
        >
          <Box display="flex" alignItems="center" width="100%">
            <Typography variant="subtitle1" fontWeight={500} sx={{ color: 'background.text' }}>
              {question.questionText || question.question}
            </Typography>
            <Box flexGrow={1} />
          </Box>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0, pb: 0 }}>
          {question.pattern === 'text' ? (
            <TextField
              fullWidth
              multiline
              rows={4}
              placeholder={question.placeholder || 'Enter your answer...'}
              value={selectedAnswers[question.id] || ''}
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                },
              }}
              InputLabelProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}
                InputProps={{
                  style: {
                    color: theme.palette.background.text,
                  },
                }}  
            />
          ) : 
          question.pattern === 'checkbox' ? (
            <FormGroup>
              {question.options.map((option, optionIndex) => (
                <FormControlLabel
                  key={optionIndex}
                  sx={{color:'background.text'}}
                  control={
                    <Checkbox
                     sx={{color:'background.text'}}
                      checked={Array.isArray(selectedAnswers[question.id]) && selectedAnswers[question.id].includes(option)}
                      onChange={e => {
                        const prev = Array.isArray(selectedAnswers[question.id]) ? selectedAnswers[question.id] : [];
                        if (e.target.checked) {
                          handleAnswerChange(question.id, [...prev, option]);
                        } else {
                          handleAnswerChange(question.id, prev.filter(o => o !== option));
                        }
                      }}
                    />
                  }
                  label={option}
                />
              ))}
            </FormGroup>
          ):
          (
            <RadioGroup
              value={selectedAnswers[question.id] || ''}
              onChange={(e) => handleAnswerChange(question.id, e.target.value)}
            >
              {question.options.map((option, optionIndex) => (
                <FormControlLabel
                  key={optionIndex}
                  value={option}
                  control={
                    <Radio
                      icon={<RadioIcon />}
                      checkedIcon={<RadioIcon />}
                      sx={{
                        '&.Mui-checked': {
                          color: 'primary.main',
                        },
                      }}
                    />
                  }
                  label={
                    <Typography variant="body1" sx={{ ml: 1, color: 'background.text' }}>
                      {option}
                    </Typography>
                  }
                  sx={{
                    margin: '8px 0',
                    padding: '8px 12px',
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: selectedAnswers[question.id] === option ? 'primary.main' : 'divider',
                    backgroundColor: selectedAnswers[question.id] === option ? 'primary.50' : 'transparent',
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                />
              ))}
            </RadioGroup>
          )}

          {/* Edit and Delete Buttons */}
          <Box
            display="flex"
            justifyContent="flex-end"
            mt={2}
            p={2}
            sx={{
              backgroundColor: 'background.paper'
            }}
          >

            {
              isSmallScreen ? (
                <>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<EditIcon fontSize="small" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditQuestion(question);
                    }}
                    sx={{
                      mr: 1,
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                        color: 'primary.contrastText',
                      },
                    }}
                  >Edit
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon fontSize="small" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteQuestionClick(question._id || question.id);
                    }}
                    sx={{
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: 'error.light',
                        color: 'error.contrastText',
                      },
                    }}
                  >Delete
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<EditIcon fontSize="small" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditQuestion(question);
                    }}
                    sx={{
                      mr: 1,
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: 'primary.light',
                        color: 'primary.contrastText',
                      },
                    }}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon fontSize="small" />}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteQuestionClick(question._id || question.id);
                    }}
                    sx={{
                      textTransform: 'none',
                      '&:hover': {
                        backgroundColor: 'error.light',
                        color: 'error.contrastText',
                      },
                    }}
                  >
                    Delete
                  </Button>
                </>
              )
            }
          </Box>
        </AccordionDetails>
      </Accordion>
    );
  };

  // Recursive render function for tree questions in accordion
  function renderQuestionTree(questions, selectedAnswers, handleAnswerChange, level = 0) {
    return questions.map((question, index) => (
      <Box key={question.id} mb={1}>
        {renderQuestionAccordion(question, index, level)}
        {question.children && question.children.length > 0 && (
          <Box ml={2}>
            {renderQuestionTree(question.children, selectedAnswers, handleAnswerChange, level + 1)}
          </Box>
        )}
      </Box>
    ));
  }

  const [questionnaireQuestions, setQuestionnaireQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch questions when selectedService changes
  useEffect(() => {
    const fetchQuestions = async () => {
      if (selectedService) {
        setIsLoading(true);
        try {
          // Ensure we're using the _id from the service object
          const service = services.find(s => s._id === selectedService);
          if (service) {
            const response = await api.get(`/questionnaire/service/${service._id}`);
            console.log(response.data.data)
            setQuestionnaireQuestions(response.data.data || []);
          } else {
            console.error('Service not found with id:', selectedService);
            setQuestionnaireQuestions([]);
          }
        } catch (error) {
          console.error('Error fetching questions:', error);
          setQuestionnaireQuestions([]);
        } finally {
          setIsLoading(false);
        }
      } else {
        setQuestionnaireQuestions([]);
      }
    };

    fetchQuestions();
  }, [selectedService, services]);

  const isAllAnswered = questionnaireQuestions.length > 0 &&
    questionnaireQuestions.every(q => selectedAnswers[q._id]);

  // Convert API questions to the format expected by renderQuestionTree
  const formatQuestionsForTree = (questions) => {
    return questions.map(q => ({
      id: q._id,
      question: q.questionText,
      pattern: q.questionType,
      options: q.options?.map(opt => opt.text) || [],
      placeholder: q.placeholder || '',
      required: q.required || false
    }));
  };

  const formattedQuestions = formatQuestionsForTree(questionnaireQuestions);

  const renderServiceQuestionnaire = () => {
    const selectedServiceData = services.find(s => s._id === selectedService);

    return (
      <Box>

        <Paper elevation={2} sx={{borderBottomLeftRadius:15,borderBottomRightRadius: 15,  borderColor: 'divider',m:-3}}>      
          {
            isSmallScreen ? (
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}  sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }} padding={1}>
                <Typography sx={{ color: 'background.text',mb:2, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',fontSize:{xs:'14px',sm:'18px'}, fontWeight: 600 }} >
                  Service Questionnaire
                </Typography>          
                <Box display="flex" gap={2}>
                  <FormControl size="small" sx={{   minWidth: { xs: 100, sm: 150},   flexShrink: 0 }}>
                    <InputLabel sx={{ color: 'background.text' , fontSize: 13}}>Select</InputLabel>
                    <Select value={selectedService || ''} label="Select Service" 
                      onChange={(e) => { setSelectedService(e.target.value);
                                        setSelectedAnswers({});
                      }}
                      sx={{  borderRadius: 2,  color: 'background.text',  width: { xs: 100, sm: 140 },fontSize: 13,height: 32,'& .MuiSelect-select': {py: 0.5},}}>
                      {services.map((service) => (
                        <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text',fontSize: 13 }}>
                          {service.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {selectedService && (
                    <Tooltip title="Add Question" arrow>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={() => {setSelectedService(selectedService); handleAddQuestion();}}
                        sx={{
                          bgcolor: theme.palette.primary.main,
                          color: theme.palette.primary.contrastText,
                          borderRadius: 3,
                          boxShadow: 2,
                          height: 30,
                          minWidth: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textTransform: "none",
                          "&:hover": {
                            bgcolor: theme.palette.primary.dark,
                            boxShadow: 4,
                          },
                          flexShrink: 0,
                        }}
                      >
                        Add Question
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </Box>
            ) : (
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={6} padding={2} gap={2} sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
                <Typography variant="h5" fontWeight={600} sx={{ color: 'background.text', fontSize: { xs: '14px', sm: '18px' } }}>Service Questionnaire</Typography>
                <Box display="flex" gap={2}>
                  <FormControl sx={{ minWidth: 200, color: 'background.text' }}>
                    <InputLabel sx={{ color: 'background.text' }}>Select Service</InputLabel>
                    <Select
                      value={selectedService || ''}
                      label="Select Service"
                      onChange={(e) => {
                        setSelectedService(e.target.value);
                        setSelectedAnswers({});
                      }}
                      sx={{ borderRadius: 2, color: 'background.text',width:{xs:'auto',md:'auto',lg:'auto'} }}
                    >
                      {services.map((service) => (
                        <MenuItem key={service._id} value={service._id} sx={{ color: 'background.text' }}>
                          {service.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {selectedService && (
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setSelectedService(selectedService);
                        handleAddQuestion();
                      }}
                      sx={{ borderRadius: 3, fontWeight: 700, textTransform: 'none' }}
                    >
                      Add Question
                    </Button>
                  )}
                </Box>
              </Box>
            )
          }
        </Paper>

        {/* <Divider sx={{margin:'5px'}} /> */}

        {isLoading ? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        ) : selectedService ? (
          <Box sx={{m:-3}}  >
            <Card sx={{ mb: 3, borderRadius: 3 }}>
              <CardContent>
                <Typography variant="h6" fontWeight={600} color="primary" gutterBottom>
                  {selectedServiceData?.name || 'Service'} - Questionnaire
                </Typography>
                <Typography variant="body2" color="background.text">
                  Please answer the following questions to help us provide better service.
                </Typography>
              </CardContent>
            </Card>

            {formattedQuestions.length > 0 ? (
              <Box>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    mb: 3,
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: 'divider',
                    backgroundColor: 'background.paper'
                  }}
                >
                  <Typography variant="h6" gutterBottom fontWeight={600} sx={{ color: 'background.text' }}>
                    Questionnaire Questions
                  </Typography>
                  <Typography variant="body2" color="background.text" mb={3}>
                    Expand each question to view and provide your response.
                  </Typography> 

                  <Box sx={{ width: '100%' }}>
                    {renderQuestionTree(formattedQuestions, selectedAnswers, handleAnswerChange)}
                  </Box>
                </Paper>

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={4}
                  p={2}
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 1,
                    border: '1px solid',
                    borderColor: 'divider',
                    zIndex: 10
                  }}
                >
                  <Box flexGrow={1} />

                  <Button
                    variant="contained"
                    // size="large"
                    onClick={handleSubmitQuestionnaire}
                    disabled={!isAllAnswered}
                    sx={{
                      borderRadius: 3,
                      fontWeight: 700,
                      textTransform: 'none',
                      px: 4,
                      py: 1.5,
                      minWidth: 200,
                      color: 'background.text'
                    }}
                  >
                    {isAllAnswered ? 'Submit Questionnaire' : 'Complete All Questions'}
                  </Button>
                </Box>
              </Box>
            ) : (
              <Paper elevation={2} sx={{ p: 4, textAlign: 'center', borderRadius: 3  }}>
                <Typography variant="h6" color="background.text" gutterBottom>
                  No questions found for this service
                </Typography>
                <Typography variant="body2" color="background.text">
                  Click "Add Question" to create a new question for this service.
                </Typography>
              </Paper>
            )}
          </Box>
        ) : (
          <Paper elevation={2} sx={{ p: 4, textAlign: 'center', borderRadius: 3 , m:-3 }}>
            <Typography variant="h6" color="background.text">
              Please select a service to view its questionnaire
            </Typography>
          </Paper>
        )}
      </Box>
    );
  };

  const renderDialog = () => {
    const isRole = dialogType === 'role';
    const title = isRole ? 'Add Role' : 'Add Service';

    return (
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: 'background.text' }}>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            <TextField
              label="Name"
              fullWidth
              value={formData.name || ''}
              onChange={(e) => {
                const value = e.target.value;   
                if (!isRole && value.length > 20) {
                  setNameError("Service name must not exceed 20 characters");
                }
                else if (isRole && value.includes(' ')) {
                  setNameError("Role name must be a single word (no spaces allowed)");
                } 
                else if(userRole.toLowerCase()!=='superadmin' && value.toLowerCase() ==='superadmin'){
                  setNameError("You are not authorized to add a superadmin");
                }
                else {
                  setNameError("");
                }
                setFormData({ ...formData, name: value });
              }}
              error={Boolean(nameError)}
              helperText={nameError}
              InputLabelProps={{style: { color: theme.palette.background.text },}}
              InputProps={{style: { color: theme.palette.background.text },}}
            />
            {
              isRole && (
                <>
                    <FormControl size="small" fullWidth>
                      <InputLabel id="service-label" sx={{ color: 'background.text' }}>
                        {!formData?.id ? 'Select Service' : 'Service'}
                      </InputLabel>

                      <Select
                        multiple
                        labelId="service-label"
                        id="service-select"
                        label={!formData?.id ? 'Select Service' : 'Service'}
                        value={formData.serviceId || []}           
                        onChange={(e) => setFormData({ ...formData, serviceId: e.target.value })}
                        sx={{ color: 'background.text' }}
                        renderValue={(selected) =>
                          services
                            .filter((s) => selected.includes(s._id))
                            .map((s) => s.name)
                            .join(', ')
                        }
                      >
                        {services.map((service) => (
                          <MenuItem key={service._id} value={service._id}>
                            <Checkbox checked={(formData.serviceId || []).includes(service._id)} />
                            <ListItemText primary={service.name} />
                          </MenuItem>
                        ))}
                      </Select>
                      <Box sx={{display:'flex'}}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.isLiveTrackingEnabled == 1}
                              onChange={(e) =>
                                setFormData({ ...formData, isLiveTrackingEnabled: e.target.checked })
                              }
                              sx={{ color: 'background.text' }}
                            />
                          }
                          label="Enable Live Tracking"
                          sx={{ display:canEnableLiveTracking?'none':'flex',color: 'background.text' }}
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={formData.isAdminRole == 1}
                              onChange={(e) =>
                                setFormData({ ...formData, isAdminRole: e.target.checked })
                              }
                              sx={{ color: 'background.text' }}
                            />
                          }
                          label="Make this role as admin"
                          sx={{ color: 'background.text' }}
                        />
                      </Box>
                    </FormControl>
                </>
              )
            }
            {!isRole && (
              <>
                <TextField
                  label="Description"
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.description || ''}
                  onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                  InputLabelProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                />

                <TextField
                  label="Price"
                  type='number'
                  fullWidth
                  value={formData.price || ''}
                  onChange={(e) => setFormData({ ...formData, price: e.target.value })}
                  InputLabelProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                  InputProps={{
                    style: {
                      color: theme.palette.background.text,
                    },
                  }}
                />
              </>
            )}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={Boolean(nameError) || !formData.name}>Save</Button>
        </DialogActions>
      </Dialog>
    );
  };

  const renderQuestionDialog = () => {
    return (
      <Dialog open={openQuestionDialog} onClose={() => setOpenQuestionDialog(false)} maxWidth="xl" fullWidth>
        <DialogTitle sx={{ color: 'background.text' }}>Add New Question</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1, color: 'background.text' }}>
            {renderQuestionForm(newQuestion)}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQuestionDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveQuestion}>Save Question</Button>
        </DialogActions>
      </Dialog>
    );
  };



  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between", 
          background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
          boxShadow:'0 2px 12px rgba(0,0,0,0.06)',
          mb: 3,
          gap: 2,
          flexWrap: "wrap", 
          p: { xs: 2, sm: 3 },
          borderRadius:'12px',
        }}
      >

        {
          isSmallScreen ? (
            <>
              <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, textTransform: 'capitalize', color: 'background.text',  }}>
                Roles & Services
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h4" fontWeight={700} sx={{ color: theme.palette.mode === 'dark' ? '#fff' : 'black' }}>Roles & Services Management</Typography>
            </>
          )
        }
        
      </Box>

      <Paper elevation={2} sx={{ borderTopLeftRadius:15,borderTopRightRadius: 15, marginTop: 3}}>
        <Tabs
          variant='scrollable'
          value={tabValue}
          onChange={handleTabChange}
          allowScrollButtonsMobile
          sx={{
            // borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': {
              fontWeight: 600,
              textTransform: 'none',
              fontSize: isSmallScreen ? 13 : 16,
              color: 'background.text',
            },
            padding: isSmallScreen ? 0 : 2,
          }}
        >
          <Tab label="Services" />
          <Tab label="User Roles" />
          {/* <Tab label="Role Permissions" /> */}
          <Tab label="Service Questionnaire" />
        </Tabs>
        
      </Paper>

      <TabPanel value={tabValue} index={0} >
          {renderServicesTable()}
        </TabPanel>

        <TabPanel value={tabValue} index={1}>
          {renderRolesTable()}
        </TabPanel>
{/* 
        <TabPanel value={tabValue} index={2}>
          {renderRolePermissionsTable()}
        </TabPanel> */}

        <TabPanel value={tabValue} index={2}>
          {renderServiceQuestionnaire()}
        </TabPanel>

      {renderDialog()}
      {renderQuestionDialog()}

      {/* <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        message={snackbar.message}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: snackbar.severity === 'error' ? '#d32f2f' : '#43a047',
          }
        }}
      /> */}



      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.text.primary }}>
          Delete {itemToDelete.type === 'service' ? 'Service' : itemToDelete.type === 'role' ? 'Role' : 'Question'}
        </DialogTitle>
        <DialogContent sx={{ bgcolor: 'transparent' }}>
          <Typography sx={{ color: 'background.text' }}>
            Are you sure you want to delete this <b>{itemToDelete.type||'question'}</b>?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} sx={{ fontWeight: 600 }}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" sx={{ fontWeight: 600 }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      
    </Box>
  );
}

export default RolesAndServicesPage; 